export const getApplicationProps = ({
  applicationSectionProgress,
  isUnInvitedSecondaryUser,
  userIsIneligible,
}) => {
  return isUnInvitedSecondaryUser
    ? {
        progress: 100,
        isComplete: true,
        disabled: true,
      }
    : {
        ...applicationSectionProgress,
        disabled: userIsIneligible,
      };
};

export const getCreditAndCriminalProps = ({
  allMembersHavePassedScreening,
  allSectionsEnabled,
  applicationProps,
  creditAndCriminalScreeningIneligible,
  creditAndCriminalSectionProgress,
  isUnInvitedSecondaryUser,
  userIsIneligible,
}) => {
  return isUnInvitedSecondaryUser
    ? {
        ...creditAndCriminalSectionProgress,
        disabled: allSectionsEnabled ? false : true,
      }
    : {
        ...creditAndCriminalSectionProgress,
        creditAndCriminalScreeningIneligible,
        isAwaitingScreeningResult:
          creditAndCriminalSectionProgress?.isComplete &&
          !allMembersHavePassedScreening,
        disabled: allSectionsEnabled
          ? false
          : userIsIneligible || !applicationProps.isComplete,
      };
};

export const getDocumentationProps = ({
  allMembersHaveCompletedDocumentation,
  allSectionsEnabled,
  creditAndCriminalProps,
  documentationSectionProgress,
  isAwaitingDocumentation,
  isUnInvitedSecondaryUser,
  userIsIneligible,
}) => {
  return isUnInvitedSecondaryUser
    ? {
        ...documentationSectionProgress,
        disabled: allSectionsEnabled ? false : true,
      }
    : {
        ...documentationSectionProgress,
        disabled: allSectionsEnabled
          ? false
          : userIsIneligible ||
            !creditAndCriminalProps.isComplete ||
            allMembersHaveCompletedDocumentation,
        isAwaitingDocumentation,
        allMembersHaveCompletedDocumentation,
      };
};
